import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_superate-aprende/artifacts/jemdy22a_LogoVectorMorado_2.0.svg";

const navLinks = [
  { label: "Inicio", href: "#inicio" },
  { label: "Cursos", href: "#cursos" },
  { label: "Cómo funciona", href: "#como-funciona" },
  { label: "Modalidades", href: "#modalidades" },
];

export default function Navbar({ onContactClick }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLinkClick = (e, href) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#1a1a1f]/90 backdrop-blur-md border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <a
            href="#inicio"
            onClick={(e) => handleLinkClick(e, "#inicio")}
            data-testid="navbar-logo"
            className="flex-shrink-0"
          >
            <img
              src={LOGO_URL}
              alt="Supérate"
              className="h-8 lg:h-10 w-auto"
            />
          </a>

          {/* Desktop links */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleLinkClick(e, link.href)}
                data-testid={`nav-link-${link.href.slice(1)}`}
                className="text-sm text-[#a1a1aa] hover:text-white transition-colors duration-200"
              >
                {link.label}
              </a>
            ))}
            <button
              onClick={onContactClick}
              data-testid="nav-cta-contact"
              className="text-sm font-medium px-5 py-2.5 rounded-lg bg-[#9d4edd] text-white hover:bg-[#7b2cbf] transition-colors duration-200"
            >
              Contacto
            </button>
          </div>

          {/* Mobile toggle */}
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden text-white p-2"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[#1a1a1f]/95 backdrop-blur-md border-t border-white/5"
        >
          <div className="px-5 py-4 space-y-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleLinkClick(e, link.href)}
                className="block py-3 text-[#a1a1aa] hover:text-white transition-colors text-base"
              >
                {link.label}
              </a>
            ))}
            <button
              onClick={() => {
                setMobileOpen(false);
                onContactClick();
              }}
              className="w-full mt-2 text-base font-medium px-5 py-3 rounded-lg bg-[#9d4edd] text-white hover:bg-[#7b2cbf] transition-colors"
            >
              Contacto
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
